import {DestroyRef, Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class TransportControlRefreshService {
  private readonly http = inject(HttpClient);
  private readonly refreshed = new Subject<void>();
  private readonly channel = typeof BroadcastChannel === 'undefined'
    ? undefined : new BroadcastChannel('crm-transport-control-refresh');

  readonly refreshed$ = this.refreshed.asObservable();

  constructor() {
    // The reminder opens the Status checks form in a separate CRM tab.
    if (this.channel) {
      this.channel.onmessage = () => this.refreshed.next();
      inject(DestroyRef).onDestroy(() => this.channel?.close());
    }
  }

  afterSave(transportId: number): void {
    this.http.post(environment.baseApi + `crm-controls/transports/${transportId}/refresh`, {}).subscribe({
      next: () => {
        this.refreshed.next();
        this.channel?.postMessage(null);
      },
      // The save already succeeded. The scheduled scan is the fallback.
      error: () => {},
    });
  }
}
